/* eslint-disable */
import React, { PropTypes } from 'react';
import './css/RatingNps.css'
import $ from 'jquery';
import ConfigD from './util/ConfigD';

class RatingNps extends React.Component {

  constructor(props, context) {
    super(props, context);
    
    this.mouseOverImg = this.mouseOverImg.bind(this);
    this.mouseOutImg = this.mouseOutImg.bind(this);
    this.clickImg = this.clickImg.bind(this);
  }

  mouseOverImg(e){
      this.props.mouseOverImg(e);
  }

  mouseOutImg(){
    this.props.mouseOutImg();
  }

  clickImg(e){
    this.props.clickImg(e, this.props.pergunta);
  }

  componentWillReceiveProps(nextProps) {
    //console.log('reiniciar pagina', nextProps.reiniciarPagina)
    if (nextProps.reiniciarPagina) {
        $('input:radio').prop('checked',false);
    }
  }
  componentDidMount(){
    //console.log('voto - ', 'nps_'+this.props.voto+this.props.pergunta.mIdCampanhaPergunta);
    if(this.props.voto!==null){
      $('#nps_'+this.props.voto+this.props.pergunta.mIdCampanhaPergunta).prop('checked',true);
    }
  }

  render() {
    //console.log('mIdCampanhaPergunta ', this.props.pergunta.mIdCampanhaPergunta)
    return (
      
        <div className="nps-selector centerRow">
          <input id={'nps_0'+this.props.pergunta.mIdCampanhaPergunta} type="radio" name={'perg'+this.props.pergunta.mIdCampanhaPergunta} value="0"/>
          <label style={{backgroundImage:'url('+ConfigD.getServerBase() + '/img/rating/nps0.png)'}} className="npstStar-cc" htmlFor={'nps_0'+this.props.pergunta.mIdCampanhaPergunta}  onMouseOver={()=>this.mouseOverImg(0)} onMouseOut={this.mouseOutImg} onClick={()=>this.clickImg(0)}></label>
          <input id={'nps_1'+this.props.pergunta.mIdCampanhaPergunta} type="radio" name={'perg'+this.props.pergunta.mIdCampanhaPergunta} value="1"/>
          <label style={{backgroundImage:'url('+ConfigD.getServerBase() + '/img/rating/nps1.png)'}} className="npstStar-cc" htmlFor={'nps_1'+this.props.pergunta.mIdCampanhaPergunta}  onMouseOver={()=>this.mouseOverImg(1)} onMouseOut={this.mouseOutImg} onClick={()=>this.clickImg(1)}></label>
          <input id={'nps_2'+this.props.pergunta.mIdCampanhaPergunta} type="radio" name={'perg'+this.props.pergunta.mIdCampanhaPergunta} value="2"/>
          <label style={{backgroundImage:'url('+ConfigD.getServerBase() + '/img/rating/nps2.png)'}} className="npstStar-cc" htmlFor={'nps_2'+this.props.pergunta.mIdCampanhaPergunta}  onMouseOver={()=>this.mouseOverImg(2)} onMouseOut={this.mouseOutImg} onClick={()=>this.clickImg(2)}></label>
          <input id={'nps_3'+this.props.pergunta.mIdCampanhaPergunta} type="radio" name={'perg'+this.props.pergunta.mIdCampanhaPergunta} value="3"/>
          <label style={{backgroundImage:'url('+ConfigD.getServerBase() + '/img/rating/nps3.png)'}} className="npstStar-cc" htmlFor={'nps_3'+this.props.pergunta.mIdCampanhaPergunta}  onMouseOver={()=>this.mouseOverImg(3)} onMouseOut={this.mouseOutImg} onClick={()=>this.clickImg(3)}></label>
          <input id={'nps_4'+this.props.pergunta.mIdCampanhaPergunta} type="radio" name={'perg'+this.props.pergunta.mIdCampanhaPergunta} value="4"/>
          <label style={{backgroundImage:'url('+ConfigD.getServerBase() + '/img/rating/nps4.png)'}} className="npstStar-cc" htmlFor={'nps_4'+this.props.pergunta.mIdCampanhaPergunta}  onMouseOver={()=>this.mouseOverImg(4)} onMouseOut={this.mouseOutImg} onClick={()=>this.clickImg(4)}></label>
          <input id={'nps_5'+this.props.pergunta.mIdCampanhaPergunta} type="radio" name={'perg'+this.props.pergunta.mIdCampanhaPergunta} value="5"/>
          <label style={{backgroundImage:'url('+ConfigD.getServerBase() + '/img/rating/nps5.png)'}} className="npstStar-cc" htmlFor={'nps_5'+this.props.pergunta.mIdCampanhaPergunta}  onMouseOver={()=>this.mouseOverImg(5)} onMouseOut={this.mouseOutImg} onClick={()=>this.clickImg(5)}></label>
          <input id={'nps_6'+this.props.pergunta.mIdCampanhaPergunta} type="radio" name={'perg'+this.props.pergunta.mIdCampanhaPergunta} value="6"/>
          <label style={{backgroundImage:'url('+ConfigD.getServerBase() + '/img/rating/nps6.png)'}} className="npstStar-cc" htmlFor={'nps_6'+this.props.pergunta.mIdCampanhaPergunta}  onMouseOver={()=>this.mouseOverImg(6)} onMouseOut={this.mouseOutImg} onClick={()=>this.clickImg(6)}></label>
          <input id={'nps_7'+this.props.pergunta.mIdCampanhaPergunta} type="radio" name={'perg'+this.props.pergunta.mIdCampanhaPergunta} value="7"/>
          <label style={{backgroundImage:'url('+ConfigD.getServerBase() + '/img/rating/nps7.png)'}} className="npstStar-cc" htmlFor={'nps_7'+this.props.pergunta.mIdCampanhaPergunta}  onMouseOver={()=>this.mouseOverImg(7)} onMouseOut={this.mouseOutImg} onClick={()=>this.clickImg(7)}></label>
          <input id={'nps_8'+this.props.pergunta.mIdCampanhaPergunta} type="radio" name={'perg'+this.props.pergunta.mIdCampanhaPergunta} value="8"/>
          <label style={{backgroundImage:'url('+ConfigD.getServerBase() + '/img/rating/nps8.png)'}} className="npstStar-cc" htmlFor={'nps_8'+this.props.pergunta.mIdCampanhaPergunta}  onMouseOver={()=>this.mouseOverImg(8)} onMouseOut={this.mouseOutImg} onClick={()=>this.clickImg(8)}></label>
          <input id={'nps_9'+this.props.pergunta.mIdCampanhaPergunta} type="radio" name={'perg'+this.props.pergunta.mIdCampanhaPergunta} value="9"/>
          <label style={{backgroundImage:'url('+ConfigD.getServerBase() + '/img/rating/nps9.png)'}} className="npstStar-cc" htmlFor={'nps_9'+this.props.pergunta.mIdCampanhaPergunta}  onMouseOver={()=>this.mouseOverImg(9)} onMouseOut={this.mouseOutImg} onClick={()=>this.clickImg(9)}></label>
          <input id={'nps_10'+this.props.pergunta.mIdCampanhaPergunta} type="radio" name={'perg'+this.props.pergunta.mIdCampanhaPergunta} value="9"/>
          <label style={{backgroundImage:'url('+ConfigD.getServerBase() + '/img/rating/nps10.png)'}} className="npstStar-cc" htmlFor={'nps_10'+this.props.pergunta.mIdCampanhaPergunta}  onMouseOver={()=>this.mouseOverImg(10)} onMouseOut={this.mouseOutImg} onClick={()=>this.clickImg(10)}></label>
        </div>

    );
  }
}
RatingNps.contextTypes = {
  router: React.PropTypes.object
};



export default RatingNps;






/** WEBPACK FOOTER **
 ** ./src/components/RatingNps.js
 **/